import { call, put, takeEvery } from 'redux-saga/effects';

import Actions from '../action';
import Axios from 'axios';
import { TOKEN_URL } from '@constants/app-constants';
import { message } from 'antd';

export function* atmServiceWorker() {
	try {
		const uri = `https://eae-clientonboarding-web-p.azurewebsites.net/api/v1/ATMLocation`;
		const res = yield call(Axios.get, uri);
		console.log('res', res);
		yield put(Actions.creators.getAtmLocationDataSuccess(res));
	} catch (err) {
		message.error('Network Error');
		yield put(Actions.creators.getAtmLocationDataError());
	}
}

export function* atmAccessTokenWorker() {
	try {
		const params = new URLSearchParams();
		// TODO : Need to update configuration in pipeline library
		params.append('client_id', '549af87db51544d99d7d68aacdc2bec8');
		params.append('client_secret', 'LYi16CbzGfS6wRDHgfYrVoLrudK1WvRQd1TY6A5s');
		params.append('grant_type', 'client_credentials');
		params.append('scope', 'erae-onboarding-api');
		params.append('acr_values', 'tenant:ae');
		const url = TOKEN_URL;
		const res = yield call(Axios.post, url, params);
		console.log('ATM RES ::', res.data.access_token);
		if (!localStorage.getItem('token')) {
			localStorage.setItem('token', res.data.access_token);
		}
		yield put(Actions.creators.getAtmAccessTokenSuccess());
	} catch (e) {
		message.error('Network error.');
	}
}

export default function* amtlocationsWatcher() {
	yield takeEvery(Actions.types.GET_ATMLOCATION_DATA_START, atmServiceWorker);
	yield takeEvery(Actions.types.GET_ATM_ACCESS_TOKEN, atmAccessTokenWorker);
}
